import request from '@/api/request.js'

// 新增
export function SystemConfigInsert(data) {
    return request({
        url: '/api/config/systemconfiginsert',
        method: 'post',
        data: data
    })
}

// 删除
export function SystemConfigDelete(id) {
    return request({
        url: `/api/config/systemconfigdelete/${id}`,
        method: 'post',
        data: {}
    })
}

// 更新
export function SystemConfigUpdate(id, data) {
    return request({
        url: `/api/config/systemconfigupdate/${id}`,
        method: 'post',
        data: data
    })
}

// 获取
export function SystemConfigGetById(id) {
    return request({
        url: `/api/config/getsystemconfigbyid/${id}`,
        method: 'get',
        data: {}
    })
}

// 获取列表
export function SystemConfigGetList(params) {
    return request({
        url: '/api/config/getsystemconfiglist',
        method: 'get',
        params: params
    })
}

// 获取分页列表
export function SystemConfigGetPageList(params) {
    return request({
        url: '/api/config/getsystemconfigpagelist',
        method: 'get',
        params: params
    })
}